import { render, staticRenderFns } from "./AppChatRoomListItem.vue?vue&type=template&id=ba657c80&scoped=true&"
import script from "./AppChatRoomListItem.vue?vue&type=script&lang=ts&"
export * from "./AppChatRoomListItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppChatRoomListItem.vue?vue&type=style&index=0&id=ba657c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba657c80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VIcon,VImg})
